export const menuItems = [
  {
    header: 'Heart Rate Variability',
    items: [
      {
        href: 'https://welltory.com/heart-rate-variability/',
        text: 'What is HRV',
      },
      {
        href: 'https://welltory.com/hrv-simplified/',
        text: 'HRV Simplified',
      },
      {
        href: 'https://welltory.com/the-12-mistakes-when-measuring-hrv/',
        text: 'HRV Mistakes',
      },
      {
        href: 'https://welltory.com/heart-rate-variability-gadgets/',
        text: 'HRV Gadgets',
      },
      {
        href: 'https://welltory.com/rules-accurate-hrv-measurements/',
        text: 'How to measure HRV',
      },
      {
        href: 'https://welltory.com/how-welltory-tracks-heartbeat/',
        text: 'How Welltory tracks Heartbeat',
      },
      {
        href: 'https://welltory.com/heart-rate-zones/',
        text: 'Heart Rate Zones',
      },
    ],
  },
  {
    header: 'Body',
    items: [
      {
        href: 'https://welltory.com/hrv/',
        text: 'Heart Rate Variability',
      },
      {
        href: 'https://welltory.com/blood-pressure/',
        text: 'Blood Pressure',
      },
      {
        href: 'https://welltory.com/stress-and-energy/',
        text: 'Stress & Energy',
      },
      {
        href: 'https://welltory.com/health/',
        text: 'Health',
      },
      {
        href: 'https://welltory.com/sleep/',
        text: 'Sleep',
      },
    ],
  },
  {
    header: 'Mind',
    items: [
      {
        href: 'https://welltory.com/meditation/',
        text: 'Meditation',
      },
      {
        href: 'https://welltory.com/productivity/',
        text: 'Productivity',
      },
      {
        href: 'https://welltory.com/sex-tracking-app/',
        text: 'Sex & Relationships',
      },
    ],
  },
  // {
  //   header: 'Behavior',
  //   items: [
  //     {
  //       href: 'https://welltory.com/activity-and-workouts/',
  //       text: 'Activity & Workouts',
  //     },
  //     {
  //       href: 'https://welltory.com/habits-and-addictions/',
  //       text: 'Habits & Addictions',
  //     },
  //     {
  //       href: 'https://welltory.com/nutrition/',
  //       text: 'Nutrition',
  //     },
  //   ],
  // },
];

export const footerItems = [
  {
    header: 'Resources',
    items: [
      {
        href: 'mailto:support@welltory.com',
        text: 'Contact Us',
      },
      {
        href: 'https://help.welltory.com/',
        text: 'Support',
      },
      {
        href: 'https://help.welltory.com/en/collections/2570042-faq',
        text: 'FAQ',
      },
      {
        href: 'https://welltory.com/rules-accurate-hrv-measurements/',
        text: 'How To Measure HRV',
      },
      {
        href: 'https://welltory.com/terms/',
        text: 'Terms of Use',
      },
      {
        href: 'https://welltory.com/privacy/',
        text: 'Privacy Policy',
      },
      {
        href: 'https://welltory.com/cookie/',
        text: 'Cookie Policy',
      },
    ],
  },
  {
    header: 'Company',
    items: [
      {
        href: 'https://welltory.com/team/',
        text: 'Team',
      },
      {
        href: 'https://welltory.com/our-story/',
        text: 'Our Story',
      },
      {
        href: 'https://welltory.com/press-kit/',
        text: 'Press Kit',
      },
      {
        href: 'https://welltory.com/testimonials/',
        text: 'Testimonials',
      },
      {
        href: 'https://welltory.com/plans/',
        text: 'Plans',
      },
    ],
  },
  {
    header: 'Developers',
    items: [
      {
        href: 'https://help.welltory.com/articles/3748589',
        text: 'Integration',
      },
      {
        href: 'https://github.com/Welltory',
        text: 'Open Source',
      },
      {
        href: 'https://github.com/Welltory/hrv-covid19',
        text: 'Covid-19 Research',
      },
      {
        href: 'mailto:security@welltory.com',
        text: 'Report Security Vulnerabilities',
      },
    ],
  },
];
